"use strict";Object.defineProperty(exports, "__esModule", {value: true});





var _chunkFBR6Y46Zjs = require('../chunk-FBR6Y46Z.js');
require('../chunk-BYIEAVCX.js');
require('../chunk-Q4G2SZRD.js');






exports.initCounters = _chunkFBR6Y46Zjs.initCounters; exports.logError = _chunkFBR6Y46Zjs.logError; exports.rumInit = _chunkFBR6Y46Zjs.rumInit; exports.sendFirstMeaningfulPaint = _chunkFBR6Y46Zjs.sendFirstMeaningfulPaint; exports.sendJSFrameworkInited = _chunkFBR6Y46Zjs.sendJSFrameworkInited;
//# sourceMappingURL=index.js.map